import { View } from 'react-native';

import { cn } from './cn';

export type CheckSize = 'sm' | 'md';

const SIZE: Record<CheckSize, string> = {
  sm: 'h-5 w-5',
  md: 'h-6 w-6',
};

export interface CheckCircleProps {
  checked: boolean;
  size?: CheckSize;
  /**
   * Draw the empty ring dashed with a page-colored fill (sealed-run timeline
   * nodes) so the rail line reads as passing behind, not through, the node.
   * No effect when `checked`.
   */
  dashed?: boolean;
  className?: string;
}

/**
 * Presentational run check — filled ink circle with a drawn check when done,
 * an empty ring when remaining. Press handling lives on the parent row.
 */
export function CheckCircle({
  checked,
  size = 'md',
  dashed,
  className,
}: CheckCircleProps) {
  return (
    <View
      className={cn(
        'items-center justify-center rounded-full',
        SIZE[size],
        checked
          ? 'bg-ink'
          : dashed
            ? 'border-[1.5px] border-dashed border-border-strong bg-background'
            : 'border-[1.5px] border-border-strong bg-transparent',
        className,
      )}
    >
      {checked ? (
        <View
          className="h-[5px] w-[9px] border-b-2 border-l-2 border-on-ink"
          style={{ transform: [{ rotate: '-45deg' }, { translateY: -1 }] }}
        />
      ) : null}
    </View>
  );
}
